// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type MinimalTrusteeFragment = { __typename?: 'Trustee', id: string, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null };

export type TrusteeFragment = { __typename?: 'Trustee', id: string, individual?: { __typename?: 'ClientProfile', displayName: string, id: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null };

export const Operations = {
  Fragment: {
    MinimalTrustee: 'MinimalTrustee' as const,
    Trustee: 'Trustee' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const MinimalTrusteeFragmentDoc = gql`
    fragment MinimalTrustee on Trustee {
  id
  individual {
    id
    displayName
  }
  organization {
    id
    name
  }
}
    `;
export const TrusteeFragmentDoc = gql`
    fragment Trustee on Trustee {
  id
  individual {
    displayName
    id
  }
  organization {
    id
    name
  }
}
    `;